import React from "react";
import CustomerCard from "../../components/CustomerCard";
import Head from "next/head";
import CtaOne from "@components/CTA/CtaOne";
import { BASE_ASSETS_URL } from "../../constants/constants";
const angelfireHeaderImage = `${BASE_ASSETS_URL}/case-studies/angelfire-bg.png`;
const harryCorryHeaderImage = `${BASE_ASSETS_URL}/case-studies/harry-corry-bg.png`;
const transporterHeaderImage = `${BASE_ASSETS_URL}/case-studies/transport-bg.png`;
const agingWithComfortHeaderImage = `${BASE_ASSETS_URL}/case-studies/aging-comfort-bg.png`;
const mancosaHeaderImage = `${BASE_ASSETS_URL}/case-studies/mancosa-bg.png`;
const rethinkHeaderImage = `${BASE_ASSETS_URL}/case-studies/rethink-bg.png`;
const beaverHeaderImage = `${BASE_ASSETS_URL}/case-studies/beaver-bg.png`;
const shineAboveHeaderImage = `${BASE_ASSETS_URL}/case-studies/shine-above-bg.png`;
const benavestHeaderImage = `${BASE_ASSETS_URL}/case-studies/benavest-bg.png`;
const abcEyecareHeaderImage = `${BASE_ASSETS_URL}/case-studies/abc-eyecare-bg.png`;
const lifeStyleDesignHeaderImage = `${BASE_ASSETS_URL}/case-studies/lifestyle-design-bg.png`;
const overStockHeaderImage = `${BASE_ASSETS_URL}/case-studies/overstock-bg.png`;

const customerCardJson = [
  {
    imageSrc: angelfireHeaderImage,
    customerName: "Angel Fire",
    customerKey: "angel-fire",
    bgColor: "bg-green-100/50",
    isCaseStudy: true,
    customerDescription:
      "Processed 300+ seasonal staff training forms — cutting onboarding time by 60%",
  },
  {
    imageSrc: harryCorryHeaderImage,
    customerName: "Harry Corry",
    customerKey: "harry-corry-ltd",
    bgColor: "bg-red-100/50",
    isCaseStudy: true,
    customerDescription:
      "Harry Corry cuts onboarding delays by digitizing HR paperwork with BoloSign",
  },
  {
    imageSrc: transporterHeaderImage,
    customerName: "G & H Transport",
    customerKey: "g-h-transport",
    bgColor: "bg-yellow-100/50",
    isCaseStudy: true,
    customerDescription:
      "Collected 300+ inspection and training acknowledgments — cutting administrative overhead by 50%",
  },
  {
    imageSrc: agingWithComfortHeaderImage,
    customerName: "Aging With Comfort",
    customerKey: "aging-comfort",
    bgColor: "bg-pink-100/50",
    isCaseStudy: true,
    customerDescription:
      "Enabled over 200 care plan acknowledgments — improving completion rates by 65%",
  },
  {
    imageSrc: mancosaHeaderImage,
    customerName: "Mancosa",
    customerKey: "mancosa",
    bgColor: "bg-orange-100/50",
    isCaseStudy: true,
    customerDescription:
      "Digitized student acknowledgment workflows — supporting over 500 form submissions with improved tracking and visibility",
  },
  {
    imageSrc: rethinkHeaderImage,
    customerName: "Rethink",
    customerKey: "rethink",
    bgColor: "bg-green-100/50",
    isCaseStudy: true,
    customerDescription:
      "Automated safety checklists across teams — achieving 90% faster documentation turnaround",
  },
  {
    imageSrc: beaverHeaderImage,
    customerName: "Beaver",
    customerKey: "beaver",
    bgColor: "bg-pink-100/50",
    isCaseStudy: true,
    customerDescription:
      "Streamlined field documentation for 10+ workflows — reducing manual errors and saving an estimated 80+ admin hours monthly",
  },
  {
    imageSrc: shineAboveHeaderImage,
    customerName: "Shine Above",
    customerKey: "shine-above",
    bgColor: "bg-green-100/50",
    isCaseStudy: true,
    customerDescription:
      "Captured 150+ caregiver consents digitally — cutting document turnaround from 5 days to 1 day",
  },
  {
    imageSrc: abcEyecareHeaderImage,
    customerName: "ABC Eyecare",
    customerKey: "abc-eyecare",
    bgColor: "bg-indigo-100/50",
    isCaseStudy: true,
    customerDescription:
      "Simplified patient onboarding with digital forms — reducing paperwork errors and accelerating completion by 60%",
  },
  {
    imageSrc: benavestHeaderImage,
    customerName: "Benavest",
    customerKey: "benavest",
    bgColor: "bg-yellow-100/50",
    isCaseStudy: true,
    customerDescription:
      "Deployed 10+ consent workflows with 600+ responses — boosting compliance readiness while reducing manual follow-up by 75%",
  },
  {
    imageSrc: lifeStyleDesignHeaderImage,
    customerName: "Life Style Design Realty",
    customerKey: "lifestyle-design",
    bgColor: "bg-purple-100/50",
    isCaseStudy: true,
    customerDescription:
      "Captured 145+ lease confirmations and guest forms — improving client document completion rates by 70%",
  },
  {
    imageSrc: overStockHeaderImage,
    customerName: "Overstock",
    customerKey: "overstock-furniture",
    bgColor: "bg-red-100/50",
    isCaseStudy: true,
    customerDescription:
      "Standardized 12+ delivery load-out forms across locations — securing 89+ digital confirmations and reducing paperwork delays by 65%",
  },
];

export const getStaticProps = async ({ params }) => {
  const customerTestimonialCardsJson = customerCardJson;
  return {
    props: { customerTestimonialCardsJson },
  };
};

const Customers = ({ customerTestimonialCardsJson }) => {
  return (
    <div className="w-full flex flex-col justify-center items-center mt-20 ">
      <Head>
        <meta charSet="utf-8" />
        <title>Customers | BoloSign</title>
        <meta
          name="description"
          content="BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="BoloSign" />
        <meta name="publisher" content="BoloSign " />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link rel="canonical" href="https://www.bolosign.com/customers/" />

        <meta property="og:url" content="https://www.bolosign.com/customers/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Customers | BoloSign" />
        <meta
          property="og:description"
          content="BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
        />
        <meta
          property="og:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/customers/"
        />
        <meta
          name="twitter:title"
          content="How to Create Google Forms Approval Workflow - BoloSign"
        />
        <meta
          name="twitter:description"
          content="BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
        />
        <meta
          name="twitter:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />
      </Head>
      <div className="max-w-screen-xl md:px-8 px-4 mx-auto text-center flex flex-col justify-center items-center sm:mb-8 ">
        <CtaOne
          heading1={`Our Customers`}
          paragraph={`Hear from our satisfied customers across various industries and see
          how we've helped them streamline their workflows and boost
          productivity.`}
          paragraphStyling={`max-w-screen-md mx-auto`}
        />
      </div>
      <div className="max-w-screen-xl md:px-8 px-4 mx-auto  flex justify-center items-center ">
        <div className="w-full max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 place-items-center gap-[20px] ">
          {customerTestimonialCardsJson.map((customer, index) => (
            <CustomerCard key={index} {...customer} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Customers;
